import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-searchbar-filters',
  templateUrl: './searchbar-filters.component.html',
  styleUrls: ['./searchbar-filters.component.css']
})
export class SearchbarFiltersComponent{
   panelOpenState = false;
 form: FormGroup;
searchText:string='';
@Input() titleDescriptionList: any[] = [];
@Input() categoryList: any[] = [];
filterList: any[] = [];
selectedList:Number=0;
selectedCount: Record<string, number> = {};
 searchTriggered = false;

  @Output() search = new EventEmitter<string>();
  @Output() reset = new EventEmitter<void>();
  @Output() panelExpanded = new EventEmitter<void>();
  @Output() filterChange = new EventEmitter<{ controlName: string, value: any[] }>();
  @Output() apply = new EventEmitter<void>();
  @ViewChild('expansionWrapper', { static: true })
  expansionWrapper!: ElementRef;
  constructor(private fb: FormBuilder) { }

private initialized = false;

@Input() filterOptions: Record<string, any[]> = {};

ngOnChanges(changes: SimpleChanges): void {
  if (!this.initialized && this.categoryList?.length) {
    this.buildFilterList();
    this.initialized = true;
    return;
  }

  // ✅ dynamically update any filter's options and clear its selection
  if (changes['filterOptions'] && this.initialized) {
    const updatedOptions = changes['filterOptions'].currentValue as Record<string, any[]>;
    Object.keys(updatedOptions).forEach(controlName => {
      const filter = this.filterList.find(f => f.controlName === controlName);
      if (filter) {
        filter.options = updatedOptions[controlName];
      }
      // clear the form control and count for any updated field
      this.form.get(controlName)?.setValue([]);
      this.selectedCount[controlName] = 0;
    });
  }
}
private buildForm() {
  this.form = this.fb.group({});
  this.filterList.forEach(filter => {
    this.form.addControl(filter.controlName, this.fb.control([]));
  });
}
private buildFilterList() {
  this.filterList = [
    {
      label: 'Category',
      placeholder: 'Select Category',
      controlName: 'category',
      options: this.categoryList || []
    },
    {
      label: 'Title/Description',
      placeholder: 'Select Title/Description',
      controlName: 'titleDescription',
      options: this.titleDescriptionList || []
    }
  ];

  this.buildForm(); // 👈 build form AFTER list is ready
}

expandPanel(event?: MouseEvent) {
  event?.stopPropagation();
  this.panelOpenState = true;

  const hadUserSearch = this.searchTriggered;

  this.searchText = '';
  this.form?.get('search')?.setValue('');

  // reset flag after clearing
  this.searchTriggered = false;

  if (hadUserSearch) {
    this.reset.emit();
  }
}

collapsePanel(event?: MouseEvent) {
  event?.stopPropagation();
  this.panelOpenState = false;
}
  triggerSearch() {
  const value = this.searchText.trim();

  if (value) {
    this.searchTriggered = true; // ✅ mark real user search
  }
   this.filterList.forEach(filter => {
    this.form.get(filter.controlName)?.setValue([]);
    this.selectedCount[filter.controlName] = 0;
  });
  this.search.emit(value);

  this.collapsePanel();
}

resetForm() {
  const hasAnySelection = Object.keys(this.form.controls).some(key => {
    const value = this.form.get(key)?.value;
    return Array.isArray(value) && value.length > 0;
  });

  if (!hasAnySelection) return;

  Object.keys(this.form.controls).forEach(key => {
    this.form.get(key)?.setValue([]);
  });

  this.resetSelectedCount();
  this.form.reset();

  this.reset.emit();
   this.panelOpenState = false;
}

private resetSelectedCount() {
  Object.keys(this.selectedCount).forEach(key => {
    this.selectedCount[key] = 0;
  });
}
onSelectAll(controlName: string) {
  const filter = this.filterList.find(f => f.controlName === controlName);
  if (!filter) return;

  const allValues = filter.options || [];

  this.form.get(controlName)?.setValue(allValues);
  this.selectedCount[controlName] = allValues.length;

  // ✅ emit for BOTH title & category dynamically
  this.filterChange.emit({
    controlName,
    value: allValues
  });
}

onClearAll(controlName: string) {
  this.form.get(controlName)?.setValue([]);
  this.selectedCount[controlName] = 0;

  // ✅ emit for BOTH title & category dynamically
  this.filterChange.emit({
    controlName,
    value: []
  });
}
onSelectionChange(controlName: string) {
  const value = this.form.get(controlName)?.value || [];

  // existing functionality (keep as it is)
  this.selectedCount[controlName] = value.length;

 this.filterChange.emit({
    controlName,
    value
  });
}
onSearchClick() {
  this.apply.emit();
   this.panelOpenState = false;
}
@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {

  if (!this.panelOpenState) {
    return;
  }

  const target = event.target as HTMLElement;

  const clickedInsidePanel =
    this.expansionWrapper.nativeElement.contains(target);

  const clickedInsideNgSelectDropdown =
    target.closest('.ng-dropdown-panel');

  const clickedToggleIcon =
    target.closest('.toggle-icon');

  if (
    !clickedInsidePanel &&
    !clickedInsideNgSelectDropdown &&
    !clickedToggleIcon
  ) {
    this.panelOpenState = false;
  }
}


}